<template>
  <nav class="breadcrumb" aria-label="breadcrumbs">
    <ul>
      <li v-for="item in breadcrumb"
        :key="item.title"
        :class="{ 'is-active': item.isActive }">
        <router-link
          v-if="item.route"
          active-class="none"
          :to="item.route">
          {{ item.title }}
        </router-link>
        <a :aria-current="isPage(item)" v-else>
          {{ item.title }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'GeneralBreadcrumb',
  props: ['breadcrumb'],
  methods: {
    isPage(item) {
      if (item.isActive) {
        return 'page';
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
</style>
